import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { fetchLevelTestSummaryAPI } from "../levelTestAPI";
import { readSessionFromUrl } from "../session";
import { rowOrderOf } from "../rowOrder";

// 레벨테스트 응시 자체를 과제 목록에 얹는다. 복습(ReviewList)과는 다른 것이다.
// 복습은 틀린 것을 되짚는 뒷일이고, 이것은 응시 한 건과 그 점수·리포트다.
//
// 카드 모양은 ReviewList 와 **같은 값**으로 맞춘다. 한 목록 안에서 세 계통(과제,
// 레벨테스트, 복습)이 다르게 생기면 학생 눈에는 그냥 깨진 화면으로 보인다.
//
// variant="finished" 는 채점이 끝난 응시, "unfinished" 는 아직 진행 중인 응시다.
const TAG_STYLE = { bg: "#EAF2FF", color: "#2F6FE0" };

const LevelTestResultList = ({ variant }) => {
  const [items, setItems] = useState([]);
  const { mode } = useSelector((state) => state.ui);
  const isMobile = mode === "mobile";

  useEffect(() => {
    const identity = readSessionFromUrl();
    if (!identity) {
      return undefined;
    }

    let isCurrent = true;
    fetchLevelTestSummaryAPI(identity.studentId, identity.randomCode)
      .then((data) => {
        if (!isCurrent) {
          return;
        }
        const results = data.results || [];
        setItems(
          results.filter((result) =>
            variant === "finished" ? result.is_finished : !result.is_finished
          )
        );
      })
      .catch(() => {
        // 레벨테스트를 안 쓰는 학원도 있다. 못 불러오면 아무것도 그리지 않는다.
      });

    return () => {
      isCurrent = false;
    };
  }, [variant]);

  if (!items.length) {
    return null;
  }

  // **감싸는 칸을 두지 않는다.** 과제 줄과 형제로 놓여야 flex order 로 날짜순
  // 자리를 잡는다. 감싸면 이 묶음이 통째로 위나 아래에 붙는다.
  return (
    <>
      {items.map((item) => {
        // 리포트가 없으면 눌러도 갈 곳이 없다. 그때는 링크가 아니라 그냥 칸으로 둔다.
        const Tag = item.report_url ? "a" : "div";

        return (
          <Tag
            key={item.session_id}
            {...(item.report_url
              ? { href: item.report_url, target: "_blank", rel: "noreferrer" }
              : {})}
            className="review-card"
            style={{
              order: rowOrderOf(item.started_at || item.taken_month),
              backgroundColor: "#FFF",
              border: "1px solid #E6EDEC",
              borderRadius: "16px",
              padding: isMobile ? "12px 14px" : "15px 18px",
              display: "flex",
              alignItems: "center",
              gap: isMobile ? "10px" : "14px",
              boxShadow: "0 10px 30px -24px rgba(20,40,50,.2)",
              flexWrap: "nowrap",
            }}
          >
            {!isMobile && (
              <div style={{ flex: "0 0 auto", width: "96px", lineHeight: 1.5 }}>
                <div style={{ fontSize: "0.8rem", color: "#7A8490", fontWeight: 600 }}>
                  레벨테스트
                </div>
                <div style={{ fontSize: "0.8rem", color: "#3A434E", fontWeight: 700 }}>
                  <em
                    style={{
                      fontStyle: "normal",
                      fontSize: "0.7rem",
                      color: "#B9C1C9",
                      fontWeight: 700,
                      marginRight: "4px",
                    }}
                  >
                    응시
                  </em>
                  {item.taken_month.replace("-", ".")}
                </div>
              </div>
            )}

            <div
              style={{
                flex: 1,
                minWidth: 0,
                display: "flex",
                alignItems: "center",
                gap: "7px",
                flexWrap: "nowrap",
                overflow: "hidden",
              }}
            >
              <span
                style={{
                  fontWeight: 700,
                  fontSize: isMobile ? "0.88rem" : "0.95rem",
                  color: "#0E141B",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  minWidth: 0,
                }}
              >
                STAGE {String(item.stage).padStart(2, "0")} {item.stage_name}
              </span>
              <span
                style={{
                  fontSize: "0.73rem",
                  fontWeight: 700,
                  padding: "3px 10px",
                  borderRadius: "999px",
                  backgroundColor: TAG_STYLE.bg,
                  color: TAG_STYLE.color,
                  flex: "0 0 auto",
                  whiteSpace: "nowrap",
                }}
              >
                레벨테스트
              </span>
            </div>

            {item.is_finished && item.score_percent !== null && (
              <span
                style={{
                  flex: "0 0 auto",
                  fontWeight: 800,
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  color: "#0E141B",
                  whiteSpace: "nowrap",
                }}
              >
                {item.score_percent}점
              </span>
            )}

            <span
              style={{
                flex: "0 0 auto",
                fontWeight: 800,
                fontSize: "0.88rem",
                color: item.report_url ? "#00A396" : "#B9C1C9",
                whiteSpace: "nowrap",
              }}
            >
              {item.report_url
                ? "리포트 보기 ›"
                : item.is_finished
                  ? "리포트 준비 중"
                  : "채점 중"}
            </span>
          </Tag>
        );
      })}
    </>
  );
};

export default LevelTestResultList;
